/**
 * Styled Components - Created by miguelcanobbio on 28/05/18.
 */
import Icon from 'antd/lib/icon'
import styled from 'styled-components'
import { GOLD_LIGHT } from '../../theme/colors'

interface DivProps {
  secondary?: boolean
}

export const Container = styled.div`
  display: flex;
  flex-flow: column;
  max-width: ${({ secondary }: DivProps) => secondary ? '280px' : 'auto'};
`

export const CardText = styled.div`
  color: #5f6062;
  font-size: 14px;
  letter-spacing: 0.11px;
  line-height: 23px;
  margin: 2px 0;
  display: flex;
  justify-content: space-between;
`

export const TitleDiv = styled.div`
  color: #b5b5b5;
  font-size: 12px;
`

export const ValueDiv = styled.div`
  font-size: 12px;
  margin-left: 10px;
  max-width: 123px;
  text-align: right;
`

export const TitleLabel = styled.div`
  background: ${GOLD_LIGHT};
  padding: 6px 12px;
  border-radius: 5px;
  font-weight: bold;
  font-family: Avenir;
  font-size: 12px;
  width: fit-content;
  align-self: flex-end;
`

export const BulkShipIcon = styled.img`
  max-width: 18px;
  margin-right: 10px;
`

export const ContactInfo = styled.div`
  background: #fbf6e0;
  padding: 4px 10px;
  font-size: 11px;
  margin-top: 10px;
  border-radius: 5px;
`

export const CircleIcon = styled(Icon)`
  background: #00aff1;
  border-radius: 25px;
  padding: 9px;
  position: absolute;
  top: -12px;
  left: 16px;
  font-size: 16px;
  color: white;
  max-width: 34px;
  width: 100%;
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/BulkAddressCard/styledComponents.tsx